import { IAddress, ITelecom } from './_types';

export const getNameTranslated = (names: any[]) => {
  let nameTranslated = '-';
  if (names && names.length > 0) {
    const name = names[0];
    const given = name.given ? name.given.join(' ') : '';
    nameTranslated = `${(name.prefix || []).join(' ')} ${given} ${name.family} ${(
      name.suffix || []
    ).join(' ')}`
      .replace(/\s+/g, ' ')
      .trim();
  }
  return nameTranslated;
};

export const getIdentifierTranslated = (ids: any[]) => {
  let identifierTranslated = '-';
  if (ids && ids.length > 0) {
    identifierTranslated = ids[0].value || '-';
  }
  return identifierTranslated;
};

export const getTelecomTranslated = (telecoms: ITelecom[], t: (key: string) => string) => {
  let telecomTranslated = '-';
  if (telecoms && telecoms.length > 0) {
    const primary = telecoms.find((telecom) => telecom.use === 'work') || telecoms[0];
    const systemMap: Record<string, string> = {
      phone: t('PatientRegistry:phone'),
      email: t('PatientRegistry:email'),
      fax: t('PatientRegistry:fax'),
      url: t('PatientRegistry:url'),
    };
    const systemLabel = systemMap[primary.system || ''] || primary.system || '';
    telecomTranslated = `${systemLabel}: ${primary.value}`;
  }
  return telecomTranslated;
};

export const getAddressTranslated = (addresses: IAddress[]) => {
  let addressTranslated = '-';
  if (addresses && addresses.length > 0) {
    const primary = addresses.find((a) => a.use === 'work') || addresses[0];
    const cityAndPostalCode = [primary.city || '', primary.postalCode || '']
      .filter(Boolean)
      .join(' ');
    const parts = [
      primary.line ? primary.line.join(', ') : '',
      cityAndPostalCode,
      primary.district || '',
      primary.state || '',
      primary.country || '',
    ].filter(Boolean);
    addressTranslated = parts.join(', ') || primary.text || '-';
  }
  return addressTranslated;
};

export const getOrganizationsTranslated = (
  organizationIds: number[] | undefined,
  orgMap: Record<number, string>,
) => {
  if (!organizationIds || organizationIds.length === 0) return '-';
  return organizationIds.map((id) => orgMap[id] || String(id)).join(', ');
};

export const getActiveTranslated = (active: boolean, t: (key: string) => string) => {
  return t(active ? 'yes' : 'no');
};

export const getGenderTranslated = (
  gender: 'male' | 'female' | 'other' | 'unknown' | undefined,
  t: (key: string) => string,
) => {
  return gender ? t(`form.gender.${gender}`) : '-';
};
